import React, { useState, useEffect } from 'react';
import { Button, Statistic } from 'antd';
import { CheckBalance } from '../../../apis/Influencer/Wallet/CheckBalance';
import { dispatch, useGlobalState } from '../../../store/state';
import CurrencyIcon from '../../Common/CurrencyIcon';
import './CreditDetailsComponent.styles.scss';
// import CreditPaymentForm from './CreditPaymentForm';
// import NumberFormat from 'react-number-format';

const CreditDetailsComponent = () => {
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    CheckBalance(user.accessToken).then(({ status, response })=>{
      console.log('API: Influ balance ==>', response);
      if (status === 200) {
        setBalance(response.wallet_balance);
        dispatch({
          type: 'SET_COMPANY',
          payload: {
            ...company,
            credit: {
              ...company.credit,
              balance: response.wallet_balance || company && company.credit && company.credit.balance,
            },
          },
        });
      } else {
        console.log('error while getting balance', response);
      }
    });
  }, []);
  return (
    <div className="common_card p-3 credit_details h-100">
      <div className="d-flex pb-2">
        <div className="col-md-7 px-0">
          <div className="credit_details_bal">
            <p>Available Balance</p>
            <h4 className="common_title">
              <CurrencyIcon size={28}/>
              <Statistic className="custom_number_format"
                value={balance}
                precision={2}/>
            </h4>
          </div>
        </div>
        <div className="col-md-5 px-0 align-self-center">
          <img src="/images/wallet.svg"
            className="img-fluid"
            alt="Wallet Image" />
        </div>
      </div>
    </div>
  );
};

export default CreditDetailsComponent;
